
import React,{useEffect,useState,useLayoutEffect} from 'react'
import './ErrorMessageComponent.css'
import { useTranslation } from 'react-i18next';
import Tooltip from "../Tooltip/Tooltip"
import { GetState, GetStateFromData } from '../../components/CustomHooks/CustomHooks';

const  ErrorMessageComponent=(props)=>{
    
    const { t } = useTranslation(['styles', 'translation']);
    const contexts = GetStateFromData();
    const {mandatoryControls} = GetState("mandatoryControls");
    const {successAndErrorMessageControlsListBasedOnAttribute}=contexts.contexts;


    useEffect(()=>{
        if(mandatoryControls && mandatoryControls.length > 0 && mandatoryControls.includes(props.id) &&document.querySelector(`[errormessageid='${props.id}_error]'`)){
            
            if(props.controlStyle && props.controlStyle.toLowerCase() == 'style2'){
                let control =document.querySelector(`[errormessageid='${props.id}_error]'`)
                control.classList.add("a_errMsgCtrlStyle2"); 
            } else{
                if(props.elem_type === "textbox"){
                }
                else{
                let control = document.querySelector(`[errormessageid='${props.id}_error]'`);
                control.classList.add("a_errMsgCtrlStyle1-3");
                }
            }
                    
        }
    },[mandatoryControls])

    useLayoutEffect(()=>{
        const time = setTimeout(()=> {
             
            if(props.id && document.getElementById("errmsgspan_"+props.id))
                document.getElementById("errmsgspan_"+props.id).classList.remove("ttErrormsg");  
        }, 5000) ;
        if( props.id && document.getElementById("errmsgspan_"+props.id)){
            document.getElementById("errmsgspan_"+props.id).classList.add("ttErrormsg");    
        }    
       
        return () => window.clearTimeout(time) ;
    },[document.getElementById("errmsgspan_"+props.id),successAndErrorMessageControlsListBasedOnAttribute?.[props.attribute] ,props.id])
    
    if(props.version=="tooltip"  ){
        return(
            successAndErrorMessageControlsListBasedOnAttribute?.[props.attribute] && 
            successAndErrorMessageControlsListBasedOnAttribute?.[props.attribute]?.includes(props.id) ?
            <div className="tooltipMainErrormessage" title="" >  {
                            
                <>
                    <span className="tooltipIconErrormessage"> 
                    </span>
                    <span id={"errmsgspan_"+props.id} className={
                        props.direction==="right"? "tooltip2Errormessage tooltipRightErrormessage":
                        props.direction==="left"? "tooltip2Errormessage tooltipLeftErrormessage":
                        props.direction==="bottom"? "tooltip2Errormessage tooltipBottomErrormessage":
                        "tooltip2Errormessage tooltipTopErrormessage" }  style={({width: props?.width ? `${props?.width}px`: '' , ...props.customStyle})}>
                         { props.parentLabel != null ? "Please enter " + props.parentLabel.toLowerCase()  : "This field can't be empty."}  
                          </span>
                </>
                }
            </div>
            :<></>
        )
    } else if( props.errorMessage) {
        return(
            <div className="tooltipMainErrormessage" title="" > 
                    <span className="tooltipIconErrormessage"> 
                    </span>
                    <span id={"errmsgspan_"+props.id} className={
                        props.direction==="right"? "tooltip2Errormessage tooltipRightErrormessage":
                        props.direction==="left"? "tooltip2Errormessage tooltipLeftErrormessage":
                        props.direction==="bottom"? "tooltip2Errormessage tooltipBottomErrormessage":
                        "tooltip2Errormessage tooltipTopErrormessage" }  
                        style={({width: props?.width ? `${props?.width}px`: '' , ...props.customStyle})}>
                         { props.errorMessage }  
                          </span>
            </div>
        )
    }  else{
        return(
            <>
            </>
        )
    } 
    
}

export default ErrorMessageComponent;